import { render, staticRenderFns } from "./admin-regions.vue?vue&type=template&id=67d4c552&scoped=true"
import script from "./admin-regions.vue?vue&type=script&lang=js"
export * from "./admin-regions.vue?vue&type=script&lang=js"
import style0 from "./admin-regions.vue?vue&type=style&index=0&id=67d4c552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4c552",
  null
  
)

export default component.exports